import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "stepper" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "stepper__circle" }
const _hoisted_4 = {
  key: 1,
  class: "stepper__number"
}
const _hoisted_5 = { class: "stepper__label" }

import { Icon } from "@iconify/vue";

interface Props {
  steps: string[];
  currentStep: number;
  // Opt-in — steppers elsewhere in the app stay purely visual unless a
  // caller explicitly asks for click-to-navigate.
  clickable?: boolean;
  // Highest step index the caller has already let the user reach. A step
  // beyond this stays inert even when clickable, so this only ever lets
  // someone jump to an already-visited step, never skip ahead into one they
  // haven't gotten to yet.
  maxStep?: number;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'Stepper',
  props: {
    steps: { default: () => [] },
    currentStep: { default: 0 },
    clickable: { type: Boolean, default: false },
    maxStep: { default: 0 }
  },
  emits: ["step-click"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const isStepClickable = (index: number) =>
  props.clickable &&
  index !== props.currentStep &&
  index <= Math.max(props.maxStep, props.currentStep);

const handleStepClick = (index: number) => {
  if (isStepClickable(index)) emit("step-click", index);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.steps, (step, index) => {
      return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
        _createElementVNode("div", {
          class: _normalizeClass([
          'stepper__step',
          {
            'stepper__step--completed': index < __props.currentStep,
            'stepper__step--active': index === __props.currentStep,
            'stepper__step--pending': index > __props.currentStep,
            'stepper__step--clickable': isStepClickable(index),
          },
        ]),
          onClick: ($event: any) => (handleStepClick(index))
        }, [
          _createElementVNode("div", _hoisted_3, [
            (index < __props.currentStep)
              ? (_openBlock(), _createBlock(_unref(Icon), {
                  key: 0,
                  icon: "solar:check-read-linear",
                  width: "14",
                  height: "14"
                }))
              : (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(index + 1), 1))
          ]),
          _createElementVNode("div", _hoisted_5, _toDisplayString(step), 1)
        ], 10, _hoisted_2),
        (index < __props.steps.length - 1)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(['stepper__line', { 'stepper__line--completed': index < __props.currentStep }])
            }, null, 2))
          : _createCommentVNode("", true)
      ], 64))
    }), 128))
  ]))
}
}

})